// Module
var code = "<div class=\"c-avatar\" :class=\"{ 'bordered': ffApplicantPhotosSignals && !!this.contact?.profile_image_url }\" :style=\"style\" data-axe-ignore> <span class=\"initials\"> {{ !contact?.profile_image_url && contact?.profile_initials ? contact?.profile_initials : '&nbsp;' }} </span> </div>";
// Exports
export default code;